import { LegendItem } from './LegendItem';


export class Legend {
    constructor(title: string, ..._legendItems: LegendItem[]) {
        this.title = title;
        this.legendItems = [...(_legendItems || [])];
    }

    legendItems: LegendItem[];
    title: string;
}
